<div class="file-uploader">
  <input
    #fileInput
    type="file"
    class="file-uploader__input"
    [attr.accept]="accept"
    [multiple]="multiple"
    [disabled]="getAriaDisabled()"
    (change)="onFileInputChange($event)" />

  <div
    class="file-uploader__dropzone"
    [class.file-uploader__dropzone--dragover]="isDragOver"
    [class.file-uploader__dropzone--disabled]="getAriaDisabled()"
    role="button"
    [attr.tabindex]="getDropzoneTabIndex()"
    [attr.aria-disabled]="getAriaDisabled()"
    (click)="openFilePicker()"
    (keydown)="onDropzoneKeydown($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    <div class="file-uploader__dropzone-icon">
      <span class="file-uploader__spinner" [class.file-uploader__spinner--hidden]="!isUploading" aria-hidden="true"></span>
      <ng-glyph [class.file-uploader__glyph--hidden]="isUploading" [name]="getDropzoneIconName()" size="28"></ng-glyph>
    </div>
    <div class="file-uploader__dropzone-copy">
      <p class="file-uploader__label">{{ label }}</p>
      <p class="file-uploader__hint">{{ getHintText() }}</p>
    </div>
    <app-button type="button" variant="secondary" [disabled]="getAriaDisabled()"> {{ getChooserLabel() }} </app-button>
  </div>

  @if (errorMessage) {
  <div class="file-uploader__error">{{ errorMessage }}</div>
  } @if (items.length > 0) { @if (isThumbnailMode()) {
  <div class="file-uploader__grid" role="list">
    @for (item of items; track item.id) {
    <div class="file-uploader__card" role="listitem">
      <div class="file-uploader__card-preview">
        @if (shouldShowImagePreview(item)) {
        <img
          class="file-uploader__card-image"
          [src]="getPreviewUrl(item)"
          [alt]="item.name"
          loading="lazy"
          (error)="onPreviewError(item.id)" />
        } @else {
        <div class="file-uploader__card-fallback">
          <span
            class="file-uploader__spinner"
            [class.file-uploader__spinner--hidden]="item.status !== 'uploading'"
            aria-hidden="true"></span>
          <ng-glyph
            [class.file-uploader__glyph--hidden]="item.status === 'uploading'"
            [name]="getItemIconName(item)"
            size="28"></ng-glyph>
        </div>
        }
      </div>
      <div class="file-uploader__card-body">
        <p class="file-uploader__item-name">{{ item.name }}</p>
        <div class="file-uploader__item-meta">
          <span>{{ formatFileSize(item.size) }}</span>
          <span>{{ getItemStatusText(item) }}</span>
        </div>
      </div>
      <div class="file-uploader__card-actions">
        @if (shouldShowOpenAction(item)) {
        <app-button
          type="button"
          variant="simple"
          (click)="openInNewTab(item, $event)"
          title="Open file in new tab"
          aria-label="Open file in new tab">
          <ng-glyph name="open_in_new" size="18"></ng-glyph>
        </app-button>
        }
        <app-button
          type="button"
          variant="simple"
          [disabled]="isRemoveDisabled(item)"
          (click)="requestRemove(item.id, $event)"
          title="Remove file"
          aria-label="Remove file">
          <ng-glyph name="close" size="18"></ng-glyph>
        </app-button>
      </div>
    </div>
    }
  </div>
  } @else {
  <div class="file-uploader__list" role="list">
    @for (item of items; track item.id) {
    <div class="file-uploader__item" role="listitem">
      <div class="file-uploader__item-main">
        <div class="file-uploader__item-icon">
          <span
            class="file-uploader__spinner file-uploader__spinner--sm"
            [class.file-uploader__spinner--hidden]="item.status !== 'uploading'"
            aria-hidden="true"></span>
          <ng-glyph
            [class.file-uploader__glyph--hidden]="item.status === 'uploading'"
            [name]="getItemIconName(item)"
            size="20"></ng-glyph>
        </div>
        <div class="file-uploader__item-copy">
          <p class="file-uploader__item-name">{{ item.name }}</p>
          <div class="file-uploader__item-meta">
            <span>{{ formatFileSize(item.size) }}</span>
            <span>{{ getItemStatusText(item) }}</span>
          </div>
        </div>
      </div>
      <div class="file-uploader__item-actions">
        @if (shouldShowOpenAction(item)) {
        <app-button
          type="button"
          variant="simple"
          (click)="openInNewTab(item, $event)"
          title="Open file in new tab"
          aria-label="Open file in new tab">
          <ng-glyph name="open_in_new" size="18"></ng-glyph>
        </app-button>
        }
        <app-button
          type="button"
          variant="simple"
          [disabled]="isRemoveDisabled(item)"
          (click)="requestRemove(item.id, $event)"
          title="Remove file"
          aria-label="Remove file">
          <ng-glyph name="close" size="18"></ng-glyph>
        </app-button>
      </div>
    </div>
    }
  </div>
  } } @else {
  <div class="file-uploader__empty">
    <p class="file-uploader__empty-title">{{ emptyStateTitle }}</p>
    <p class="file-uploader__empty-description">{{ emptyStateDescription }}</p>
  </div>
  }
</div>
